import type { ErrorStatusApiResponse } from '@/types/site';
import { XHRAuthorizedClient } from '../client';
import { ENDPOINTS } from '../endpoints';

export const fetchErrorStatus = async (siteId: string) => {
  const response = await XHRAuthorizedClient.get<ErrorStatusApiResponse>(
    ENDPOINTS.dashboard.errorStatus(siteId)
  );

  return response.data.data;
};
